import API from "./api";

export async function fetchOrgAuditLogs({ limit = 300, q } = {}) {
  const params = { limit };
  if (q && String(q).trim()) {
    params.q = String(q).trim();
  }
  const { data } = await API.get("/audit/logs", { params });
  return data;
}
